import { render, staticRenderFns } from "./chateau-lynch-bages.vue?vue&type=template&id=9f059fd4&scoped=true"
import script from "./chateau-lynch-bages.vue?vue&type=script&lang=js"
export * from "./chateau-lynch-bages.vue?vue&type=script&lang=js"
import style0 from "./chateau-lynch-bages.vue?vue&type=style&index=0&id=9f059fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f059fd4",
  null
  
)

export default component.exports